import React, { useEffect, useState } from 'react';
import Cart from '../Cart/Cart';
import Nav from '../Nav/Nav';
import QnA from '../QnA/QnA';
import Student from '../Student/Student';
import './Students.css'

const Students = () => {
    const [students,setStudents] = useState([]);
    const [studentDetails,setStudentDetails] =useState([]);
    useEffect(()=>{

        fetch(`player.json`)
         .then(res =>res.json())
          .then(data=>setStudents(data))
    },[]);
    const handleAddToCart =(value)=>{
        console.log(value);
        let arr=[];
        arr=[...studentDetails,value];
        setStudentDetails(arr);
    }
    
    return (
        <div>
            <div className='student-details'>
                <div>
                    <Nav></Nav>
                    <div className='student-cart'>
                        {
                            students.map(student => <Student student={student} handleAddToCart={handleAddToCart}></Student>)
                        }
                    </div>
                </div>

                <div className='sticky'>
                    {
                        <Cart studentDetails={studentDetails}></Cart>
                    }
                </div>
                
            </div>
            <QnA></QnA>
        </div>
        
    );
};

export default Students;